import React, { useState, useEffect, useRef } from "react";
import { withRouter } from "react-router-dom";

const Login = (props) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  // A ref to track whether the component is mounted
  const isMounted = useRef(true);

  useEffect(() => {
    // When component unmounts, set the flag to false
    return () => {
      isMounted.current = false;
    };
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { default: axios } = await import("axios");
      console.log("starting auth");
      const response = await axios.post('/api/auth/login', {
        email,
        password
      });
      if (isMounted.current) {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem("userLoginId", response.data.loginId || "2");
        // Redirect the user after successful login.
        props.history.push('/');
      }
    } catch (err) {
      if (isMounted.current) {
        setError('Invalid credentials');
      }
    }
    if (isMounted.current) {
      setLoading(false);
    }
  };

  return (
    <div
  className="RowContent"
  style={{
    maxWidth: "800px",
    margin: "10vh auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  }}
>
  <div className="card-style" style={{ width: "100%", padding: "2rem 0 2rem 0" }}>
    <h3 style={{ textAlign: "center" }}>
      Please enter your Email and your Password to access
    </h3>
    <form
      onSubmit={handleSubmit}
      style={{
        width: "100%",
        maxWidth: "400px",
        margin: "0 auto",
        textAlign: "center",
      }}
    >
      <div style={{ marginBottom: "20px" }}>
        <label style={{ display: "block", marginBottom: "10px" }}>
          Email:
        </label>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Email"
          style={{
            width: "100%",
            padding: "5px 10px",
            boxSizing: "border-box",
          }}
        />
      </div>
      <div style={{ marginBottom: "20px" }}>
        <label style={{ display: "block", marginBottom: "10px" }}>
          Password:
        </label>
        <input
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          style={{
            width: "100%",
            padding: "5px 10px",
            boxSizing: "border-box",
          }}
        />
      </div>
      <button
        type="submit"
        disabled={loading}
        className="btn btn-primary"
        style={{ display: "block", margin: "0 auto 20px", padding: "5px 20px" }}
      >
        {loading ? "Logging in..." : "Login"}
      </button>
      {error && <p style={{ textAlign: "center" }}>{error}</p>}
    </form>
  </div>
</div>


  );
};

export default withRouter(Login);
